(function () {
    'use strict';

    angular
        .module('salesflare')
        .service('themeService', themeService);

    function themeService($rootScope, model) {

        this.get = function () {

            if (model.me) {

                if (model.me.theme === 'dark' || (model.me.theme === 'system' && $rootScope.systemTheme === 'dark')) {
                    return 'dark';
                }
            }
            else if ($rootScope.systemTheme === 'dark') {
                return 'dark';
            }

            return 'light';
        };
    }
})();
